module.exports = __webpack_public_path__ + "static/media/gold.3dc478d5.png";